/**
 * @description This is for the local directory
 */
import axios from "axios";
let actions = {
    /**
     * @returns {Promise<Array>}
     */
    getAllUsers(group) {
        return new Promise((resolve, reject) => {
            axios.get("/group/user",{
                params:{
                    group:group
                }
            })
                .then(data => {
                    let users = data.data.object;
                    resolve(users);
                })
                .catch(err => {
                    reject(err);
                })
        })
    },
    /**
     * 
     * @param {String} id Name of the user
     */
    addUser(id,group) {
        return new Promise((resolve, reject) => {
            axios.post("/group/user", { _id:id},{params:{group:group}})
                .then(data => {
                    let user = data.data.object;
                    resolve(user)
                })
                .catch(err => { reject(err) })
        })
    },
    /**
     * 
     * @param {Array<String>} ids 
     */
    bulkAddUser(ids,group){
        let promises = []
        ids.forEach(obj=>{
            promises.push(actions.addUser(obj,group))
        })
        return Promise.all(promises);
    },
    removeUser(id,group) {
        return new Promise((resolve, reject) => {
            axios.delete("/group/user",{data:{_id:id},params:{group:group}})
                .then(data => {
                    // let user = data.data.object;
                    resolve()
                })
                .catch(err => { reject(err) })

        })
    },
    getUser(id,group) {
        return new Promise((resolve, reject) => {
            axios.get("/group/user",{
                params:{
                    group:group,
                    _id:id
                }
            })
                .then(data => {
                    let user = data.data.object;
                    resolve(user);
                })
                .catch(err => {
                    reject(err);
                })
        })
    },
}
export default actions;